export enum LayoutType {
  Grid3x3 = 'grid3x3',
  GridLongShort3ShortLong = 'gridLongShort3ShortLong',
  Grid1Big3Under = 'grid1Big3Under',
  GridRows3x2x3 = 'gridRows3x2x3',
  Grid1Big3Side = 'grid1Big3Side',
}
